export default __webpack_public_path__ + "static/media/icon_company_green.fe7a6866.svg";